import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum AGENCY_FORM_FIELD {
	AGENCY_NAME = 'name',
	RISK_FEE = 'riskFee',
	PERCENTAGE = 'percentage',
	FEE_AMOUNT = 'feeAmount',
	REFUND_FEE = 'refundFee',
	CHARGEBACK_FEE = 'chargebackFee',
}

export enum AGENCY_FORM_FIELD_NAMES {
	AGENCY_NAME = 'Agency name',
	RISK_FEE = 'Risk fee',
	PERCENTAGE = 'Percentage',
	FEE_AMOUNT = 'Fee amount',
	REFUND_FEE = 'Refund fee',
	CHARGEBACK_FEE = 'Chargeback fee',
}

export type AgencyTypes = {
	[AGENCY_FORM_FIELD.AGENCY_NAME]: string
	[AGENCY_FORM_FIELD.RISK_FEE]: number | string
	[AGENCY_FORM_FIELD.PERCENTAGE]: number | string
	[AGENCY_FORM_FIELD.FEE_AMOUNT]: number | string
	[AGENCY_FORM_FIELD.REFUND_FEE]: number | string
	[AGENCY_FORM_FIELD.CHARGEBACK_FEE]: number | string
}

export type AgencyReturnTypes = {
	name: string,
	riskFee: number | string,
	percentage: number | string,
	feeAmount: number | string,
	refundFee: number | string,
	chargebackFee: number | string
}

export const getAgencyDetailsSchema = (): Yup.SchemaOf<AgencyTypes> => Yup.object<Shape<AgencyTypes>>().shape({
	[AGENCY_FORM_FIELD.AGENCY_NAME]: Yup.string()
		.required('Name is required'),
	[AGENCY_FORM_FIELD.RISK_FEE]: Yup.number()
		.required('Risk fee is required'),
	[AGENCY_FORM_FIELD.PERCENTAGE]: Yup.number()
		.required('Percentage is required'),
	[AGENCY_FORM_FIELD.FEE_AMOUNT]: Yup.number()
		.required('Fee amount is required'),
	[AGENCY_FORM_FIELD.REFUND_FEE]: Yup.number()
		.required('Refund fee is required'),
	[AGENCY_FORM_FIELD.CHARGEBACK_FEE]: Yup.number()
		.required('Chargeback fee is required'),

});

export const initialAgencyValues = {
	[AGENCY_FORM_FIELD.AGENCY_NAME]: '',
	[AGENCY_FORM_FIELD.RISK_FEE]: '',
	[AGENCY_FORM_FIELD.PERCENTAGE]: '',
	[AGENCY_FORM_FIELD.FEE_AMOUNT]: '',
	[AGENCY_FORM_FIELD.REFUND_FEE]: '',
	[AGENCY_FORM_FIELD.CHARGEBACK_FEE]: '',
};

export const getFormattedAgencyFormFields = (formikValues): AgencyReturnTypes => ({
	name: formikValues?.[AGENCY_FORM_FIELD.AGENCY_NAME],
	riskFee: formikValues?.[AGENCY_FORM_FIELD.RISK_FEE],
	percentage: formikValues?.[AGENCY_FORM_FIELD.PERCENTAGE],
	feeAmount: formikValues?.[AGENCY_FORM_FIELD.FEE_AMOUNT],
	refundFee: formikValues?.[AGENCY_FORM_FIELD.REFUND_FEE],
	chargebackFee: formikValues?.[AGENCY_FORM_FIELD.CHARGEBACK_FEE],
});

export const convertToAgencyInitial = (data: any): AgencyTypes => ({
	[AGENCY_FORM_FIELD.AGENCY_NAME]: data?.name,
	[AGENCY_FORM_FIELD.RISK_FEE]: data?.riskFee,
	[AGENCY_FORM_FIELD.PERCENTAGE]: data?.percentage,
	[AGENCY_FORM_FIELD.FEE_AMOUNT]: data?.feeAmount,
	[AGENCY_FORM_FIELD.REFUND_FEE]: data?.refundFee,
	[AGENCY_FORM_FIELD.CHARGEBACK_FEE]: data?.chargebackFee,
});

interface ISalesAgent {
	id: string;
	name: string;
	contact: ISalesAgentContact;
}

interface ISalesAgentContact {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	userActive: boolean;
	role: string;
}

export interface IAgency {
	id?: string;
	name: string;
	salesAgents?: ISalesAgent[];
}
